import { render, staticRenderFns } from "./WpEmbed.vue?vue&type=template&id=403f87ba"
import script from "./WpEmbed.vue?vue&type=script&lang=js"
export * from "./WpEmbed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/devstark/spreadsimple/spreadsimple-app/main-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('403f87ba')) {
      api.createRecord('403f87ba', component.options)
    } else {
      api.reload('403f87ba', component.options)
    }
    module.hot.accept("./WpEmbed.vue?vue&type=template&id=403f87ba", function () {
      api.rerender('403f87ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/wp-embed/WpEmbed.vue"
export default component.exports